<template>
  <v-app v-cloak>
    <Loading v-show="loading"></Loading>
    <T v-show="!loading"></T>
    <Header v-show="!loading"></Header>
    <v-main v-show="!loading">
      <v-container fluid class="pa-0">
        <div class="bg">
          <transition mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </v-container>
    </v-main>
    <AgeConfirmation ref="AgeConfirmation" />
  </v-app>
</template>

<script>
import Header from "./components/organisms/common/Header.vue";
import Loading from "./components/organisms/common/Loading.vue";
import T from "./components/organisms/common/t.vue";
import AgeConfirmation from "@/components/organisms/AgeConfirmation.vue";

export default {
  name: "app",
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    if (this.$route.path != "/") {
      this.$router.push("/");
    }
    setTimeout(() => {
      this.loading = false;
      //this.loading = true;
      this.$refs.AgeConfirmation.open();
    }, 1000);
  },
  components: { Header, Loading, T, AgeConfirmation },
};
</script>
>
<style lang="scss">
/* アニメーション中のスタイル */
.v-leave-active,
.v-enter-active {
  transition: opacity 1s;
}

/* 表示アニメーション */
.v-enter {
  opacity: 0;
}
.v-enter-to {
  opacity: 1;
}

/* 非表示アニメーション */
.v-leave {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}
</style>
